// Some pages pass `title` (the antd Breadcrumb prop name) instead of
// `pageName`; accept both so their heading is not left blank.
const Breadcrumb = ({ pageName, title, span, company }) => {
  return (
    <div className="mb-6 flex flex-col gap-3">
      <div className="flex flex-wrap gap-x-4">
        <h2 className="text-title-md2 text-2xl sm:text-3xl font-semibold text-primary">
          {pageName ?? title}
        </h2>
        <h2 className="text-title-md2 text-2xl sm:text-3xl font-semibold text-blue">
          {span}
        </h2>
        <h2 className="text-title-md2 text-2xl sm:text-3xl font-semibold text-blue">
          {company}
        </h2>
      </div>
      <div className="block border-b-2 w-full border-primary"></div>
    </div>
  );
};

export default Breadcrumb;
